import React from 'react';
import './styles.scss';

interface Props {
  backgroundImage: string;
  mobilebackgroundImage: string;
  title: string;
	mobiletitle: string;
	description: string;
  slides_shapes: string;
  slides_to_show: string;
  banner_top_shadow: string;
  banner_top_shadow_opacity: string;
  banner_bottom_shadow: string;
  banner_bottom_shadow_opacity: string;
  paragraphId:string;
  sub_heading:string
}

const Image: React.FC<Props> = ({ backgroundImage, mobilebackgroundImage, title, mobiletitle, description, slides_to_show, banner_top_shadow, paragraphId,banner_top_shadow_opacity, banner_bottom_shadow, banner_bottom_shadow_opacity, slides_shapes, sub_heading }) => {
  return (
      <div className="card extra-large text-center bg mb-0 full-height-of-card">
        <div className={"card-inner card-inner-"+parseInt(paragraphId)}>
          <div
            className="card-bg bg desktop-bg"
            style={{ background: `url("${backgroundImage}")` }}/>
					<div
            className="card-bg bg mobile-bg"
            style={{ background: `url("${mobilebackgroundImage}")` }}/>
          <div className="card-header">
            <h2 className="desktop-header dynamic-title">{title}</h2>
            <h2 className="mobile-header dynamic-title">{mobiletitle}</h2>
						<h4 className="sub-heading dynamic-title" dangerouslySetInnerHTML={{
                      __html: sub_heading,
                    }} />
          </div>
          <div className="card-body"/>
          <div className="card-footer dynamic-description" dangerouslySetInnerHTML={{
                      __html: description,
                    }} />
        </div>
      </div>
  );
};

export default Image;
